class Filters {
    constructor() {
        this.dropdown = null;
        this.toggles = document.getElementsByClassName( 'fv-filter__toggle' );
        this.selectedToggle = null;
        this.checkboxes = [];
        this.searchField = document.getElementById( 'fv-partner-searchfield' );
        this.submitTimeout = null;
    }

    /**
     * Init the filters.
     */
    init() {
        if ( ! this.toggles ) {
            return;
        }

        Array.from( this.toggles ).forEach( ( toggle ) => {
            toggle.onclick = ( e ) => {
                e.stopPropagation();
                e.preventDefault();
                e.stopImmediatePropagation();
                this.selectedToggle = toggle;
                this.toggleFilterStatus( 'false' === toggle.getAttribute( 'aria-pressed' ) )
                return false; // Otherwise Form wil be submitted.
            }

            toggle.addEventListener( 'keyup', ( e ) => {
                if ( !! e.isTrusted && 'Escape' === e.key ) {
                    this.closeFilter();
                }
            } );
        } );
    }

    /**
     * Init for the searchField events.
     * @return {boolean}
     */
    searchFieldEvents() {
        if ( ! this.searchField ) {
            return false;
        }

        this.searchField.addEventListener( 'focusin', () => {
            this.searchField.parentNode.classList.add( 'is-focus' );
        } );

        this.searchField.addEventListener( 'blur', () => {
            if( ! this.searchField.value ) {
                this.searchField.parentNode.classList.remove( 'is-focus' );
            }
            this.searchField.classList.remove( 'no-focus-visible' );
        } );

        this.searchField.addEventListener( "keydown", ( e ) => this.isClickOrKeyPress( e ), true );
        this.searchField.addEventListener( "mousedown", ( e ) => this.isClickOrKeyPress( e ), true );
    }

    /**
     * Due to the issue with Form-inputs where `:focus` and `:focus-visible` are working exactly the same
     *
     * @param {event} event The event.
     */
    isClickOrKeyPress( event ) {
        const inputEnteredByClick = 'mousedown' === event?.type;

        // Remove all no-focus-visible.
        if ( ! inputEnteredByClick && !! this.searchField.classList.contains( 'no-focus-visible' ) ) {
            this.searchField.classList.remove( 'no-focus-visible' );
        }

        // Add only if we need it.
        if ( !! inputEnteredByClick ) {
            this.searchField.classList.add( 'no-focus-visible' )
        }
    }

    /**
     * Toggle the status of the filter toggle.
     *
     * @param {boolean} open To open or close.
     */
    toggleFilterStatus( open ) {
        if ( !! open ) {
            this.openFilter();
        } else {
            this.closeFilter();
        }
    }

    /**
     * Firing all attribute-changes for opening the filter.
     */
    openFilter() {
        this.dropdown = this.selectedToggle.nextElementSibling;
        this.checkboxes = this.dropdown.getElementsByTagName( 'input' );
        this.closeOtherFilters();
        this.checkIndeterminate();

        if ( !! this.selectedToggle ) {
            this.selectedToggle.setAttribute( 'aria-pressed', true );
        }

        if ( !! this.dropdown ) {
            this.dropdown.setAttribute( 'aria-expanded', true );
        }

        if ( !! this.checkboxes ) {
            Array.from( this.checkboxes ).forEach( ( i ) => i.tabIndex = 0 );
        }

        const filterButton = this.dropdown.getElementsByTagName( 'button' );
        if ( !! filterButton ) {
            Array.from( filterButton ).forEach( ( b ) => b.tabIndex = 0 );
        }
    }

    /**
     * Firing all attribute-changes for closing the filter.
     */
    closeFilter() {
        if ( !! this.checkboxes ) {
            Array.from( this.checkboxes ).forEach( ( i ) => i.tabIndex = -1 );
        }

        if ( !! this.selectedToggle ) {
            this.selectedToggle.setAttribute( 'aria-pressed', false );
        }

        if ( !! this.dropdown ) {
            this.dropdown.setAttribute( 'aria-expanded', false );
        }

        const filterButton = this.dropdown.getElementsByTagName( 'button' );
        if ( !! filterButton ) {
            Array.from( filterButton ).forEach( ( b ) => b.tabIndex = -1 );
        }

        this.checkboxes = [];
    }

    /**
     * Closing all other filters.
     *
     * @return {boolean}
     */
    closeOtherFilters() {
        const openToggles = Array.from( this.toggles ).filter( ( toggle ) => 'true' === toggle.getAttribute( 'aria-pressed' ) && toggle !== this.selectedToggle );
        if ( !! openToggles && openToggles.length > 0 ) {
            openToggles.forEach( toggle => {
                toggle.setAttribute( 'aria-pressed', false );
                toggle.nextElementSibling.setAttribute( 'aria-expanded', false );
                Array.from( toggle.nextElementSibling.getElementsByTagName( 'input' ) ).forEach( ( i ) => i.tabIndex = -1 );
                Array.from( toggle.nextElementSibling.getElementsByTagName( 'button' ) ).forEach( ( b ) => b.tabIndex = -1 );
            } );
        }

        return false;
    }

    /**
     * Check for inderminate for checkboxes.
     */
    checkIndeterminate() {
        Array.from( this.checkboxes ).forEach( ( checkbox ) => {
            this.setIndeterminateOnParent( checkbox );

            checkbox.onclick = () => {
                this.setIndeterminateOnParent( checkbox );
                const children = Array.from( checkbox.parentNode.getElementsByTagName( 'input' ) );
                if ( children ) {
                    children.filter( ( i ) => i !== checkbox ).forEach( child => child.checked = !! checkbox.checked );
                }

                if ( ! checkbox.parentNode.parentNode.classList.contains( 'fv-filter__dropdown-content' ) ) {
                    const allChildren = Array.from( checkbox.parentNode.parentNode.getElementsByTagName( 'input' ) );
                    const checkedChildren = allChildren.filter( ( i ) => i.checked );
                    const parentCheckbox = checkbox.parentNode.parentNode.previousSibling.previousSibling.previousSibling;

                    if ( allChildren.length === checkedChildren.length ) {
                        // Set Checked.
                        parentCheckbox.indeterminate = false; // This property overrules :checked.
                        parentCheckbox.checked = checkedChildren.length !== 0;
                    } else {
                        // Set indeterminate.
                        parentCheckbox.indeterminate = checkedChildren.length !== 0;
                    }
                }

                this.applyFilters( checkbox );
            }

            checkbox.addEventListener( 'keyup', ( e ) => {
                // On keyup space/enter fire a click.
                if ( !! e.isTrusted && ( 'Space' === e.key || ' ' === e.key || 'Enter' === e.key ) ) {
                    checkbox.click();
                }
            } )
        } );
    }

    /**
     * Apply the filters by reloading with the selected values in the URL.
     *
     * There is no apply-button: every checkbox applies itself. Debounced so ticking a few boxes
     * in a row results in a single navigation, and paging is reset because the new selection has
     * its own result set.
     *
     * @param {HTMLObjectElement} element An element within the filter form.
     */
    applyFilters( element ) {
        const form = element.closest( 'form' );
        if ( ! form ) {
            return;
        }

        clearTimeout( this.submitTimeout );

        this.submitTimeout = setTimeout( () => {
            const params = new URLSearchParams();
            new FormData( form ).forEach( ( value, key ) => value && params.append( key, value ) );

            const path = form.getAttribute( 'action' ) || window.location.pathname.replace( /page\/\d+\/?$/, '' );
            const query = params.toString();

            window.location.assign( query ? `${ path }?${ query }` : path );
        }, 400 );
    }

    /**
     * Set the indeterminate on the parent checkbox.
     * @param {HTMLObjectElement} checkbox The Checkbox input.
     */
    setIndeterminateOnParent( checkbox ) {
        // Set parent active.
        if ( ! checkbox.parentNode.parentNode.classList.contains( 'fv-filter__dropdown-content' ) ) {
            if ( checkbox.checked ) {
                checkbox.parentNode.parentNode.previousSibling.previousSibling.previousSibling.indeterminate = true;
            }
        }
    }
}

export default Filters;
